import script from "./FilterComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterComponent.vue?vue&type=script&setup=true&lang=js"

import "./FilterComponent.vue?vue&type=style&index=0&id=2417bd8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2417bd8b"]])

export default __exports__